import {
  disabled,
  max,
  min,
  required,
  type SchemaPathTree,
} from '@angular/forms/signals';
import {
  TRACKER_CONFIG_MAXIMUM_WAVE_COUNT,
  TRACKER_CONFIG_FORM_MESSAGES,
  TRACKER_CONFIG_MINIMUM_WAVE_COUNT,
} from '../utils/tracker-config-drawer.constants';
import { TrackerConfigFormValues } from '../tracker-config-drawer.types';
import { trackerConfigDrawerWavesExcludeExceedsCountMessage } from '../utils/tracker-config.helper';

export const TRACKER_CONFIG_DRAWER_FORM_DEFAULTS = {
  numberOfWaves: 5,
  waveFrequencyAmount: 3,
  waveFrequencyUnit: 'm',
  exclusionRuleKind: 'lastWave',
  customWavesExclude: 0,
} satisfies TrackerConfigFormValues;

export function bindTrackerConfigDrawerFormSchema(
  path: SchemaPathTree<TrackerConfigFormValues>,
): void {
  required(path.numberOfWaves, {
    message: TRACKER_CONFIG_FORM_MESSAGES.NUMBER_OF_WAVES_REQUIRED,
  });
  min(path.numberOfWaves, TRACKER_CONFIG_MINIMUM_WAVE_COUNT, {
    message: TRACKER_CONFIG_FORM_MESSAGES.NUMBER_OF_WAVES_RANGE,
  });
  max(path.numberOfWaves, TRACKER_CONFIG_MAXIMUM_WAVE_COUNT, {
    message: TRACKER_CONFIG_FORM_MESSAGES.NUMBER_OF_WAVES_RANGE,
  });

  required(path.waveFrequencyAmount, {
    message: TRACKER_CONFIG_FORM_MESSAGES.WAVE_FREQUENCY_REQUIRED,
  });
  min(path.waveFrequencyAmount, 1, {
    message: TRACKER_CONFIG_FORM_MESSAGES.WAVE_FREQUENCY_MIN,
  });

  // Custom exclusion rule
  disabled(
    path.customWavesExclude,
    (ctx) => ctx.valueOf(path.exclusionRuleKind) !== 'custom',
  );
  required(path.customWavesExclude, {
    message: TRACKER_CONFIG_FORM_MESSAGES.WAVES_EXCLUDE_REQUIRED,
  });
  min(path.customWavesExclude, 0, {
    message: TRACKER_CONFIG_FORM_MESSAGES.WAVES_EXCLUDE_MIN,
  });
  max(
    path.customWavesExclude,
    ({ valueOf }) => valueOf(path.numberOfWaves) ?? undefined,
    {
      message: ({ valueOf }) =>
        trackerConfigDrawerWavesExcludeExceedsCountMessage(
          valueOf(path.numberOfWaves) ?? 0,
        ),
    },
  );
}
